import type * as Types from '../../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GenomeComboBoxDataFragment = { id: number, name: string | null, species: { id: number, name: string } | null };

export type SearchSequencedGenomeQueryVariables = Types.Exact<{
  searchTerm: Types.Scalars['String']['input'];
  limit: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type SearchSequencedGenomeQuery = { search: { sequencedGenomes: { genomes: Array<{ id: number, name: string | null, species: { id: number, name: string } | null }> } } };

export type GetGenomeQueryVariables = Types.Exact<{
  organismId: Types.Scalars['Long']['input'];
}>;


export type GetGenomeQuery = { organism: { id: number, name: string | null, species: { id: number, name: string } | null } | null };

export const GenomeComboBoxDataFragmentDoc = gql`
    fragment GenomeComboBoxData on Organism {
  id
  name
  species {
    id
    name
  }
}
    `;
export const SearchSequencedGenomeDocument = gql`
    query searchSequencedGenome($searchTerm: String!, $limit: Int) {
  search {
    sequencedGenomes(searchTerm: $searchTerm, limit: $limit) {
      genomes {
        ...GenomeComboBoxData
      }
    }
  }
}
    ${GenomeComboBoxDataFragmentDoc}`;

/**
 * __useSearchSequencedGenomeQuery__
 *
 * To run a query within a React component, call `useSearchSequencedGenomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSequencedGenomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSequencedGenomeQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchSequencedGenomeQuery(baseOptions: Apollo.QueryHookOptions<SearchSequencedGenomeQuery, SearchSequencedGenomeQueryVariables> & ({ variables: SearchSequencedGenomeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSequencedGenomeQuery, SearchSequencedGenomeQueryVariables>(SearchSequencedGenomeDocument, options);
      }
export function useSearchSequencedGenomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSequencedGenomeQuery, SearchSequencedGenomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSequencedGenomeQuery, SearchSequencedGenomeQueryVariables>(SearchSequencedGenomeDocument, options);
        }
export function useSearchSequencedGenomeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchSequencedGenomeQuery, SearchSequencedGenomeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchSequencedGenomeQuery, SearchSequencedGenomeQueryVariables>(SearchSequencedGenomeDocument, options);
        }
export type SearchSequencedGenomeQueryHookResult = ReturnType<typeof useSearchSequencedGenomeQuery>;
export type SearchSequencedGenomeLazyQueryHookResult = ReturnType<typeof useSearchSequencedGenomeLazyQuery>;
export type SearchSequencedGenomeSuspenseQueryHookResult = ReturnType<typeof useSearchSequencedGenomeSuspenseQuery>;
export type SearchSequencedGenomeQueryResult = Apollo.QueryResult<SearchSequencedGenomeQuery, SearchSequencedGenomeQueryVariables>;
export const GetGenomeDocument = gql`
    query getGenome($organismId: Long!) {
  organism(organismId: $organismId) {
    ...GenomeComboBoxData
  }
}
    ${GenomeComboBoxDataFragmentDoc}`;

/**
 * __useGetGenomeQuery__
 *
 * To run a query within a React component, call `useGetGenomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGenomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGenomeQuery({
 *   variables: {
 *      organismId: // value for 'organismId'
 *   },
 * });
 */
export function useGetGenomeQuery(baseOptions: Apollo.QueryHookOptions<GetGenomeQuery, GetGenomeQueryVariables> & ({ variables: GetGenomeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGenomeQuery, GetGenomeQueryVariables>(GetGenomeDocument, options);
      }
export function useGetGenomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGenomeQuery, GetGenomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGenomeQuery, GetGenomeQueryVariables>(GetGenomeDocument, options);
        }
export function useGetGenomeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGenomeQuery, GetGenomeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGenomeQuery, GetGenomeQueryVariables>(GetGenomeDocument, options);
        }
export type GetGenomeQueryHookResult = ReturnType<typeof useGetGenomeQuery>;
export type GetGenomeLazyQueryHookResult = ReturnType<typeof useGetGenomeLazyQuery>;
export type GetGenomeSuspenseQueryHookResult = ReturnType<typeof useGetGenomeSuspenseQuery>;
export type GetGenomeQueryResult = Apollo.QueryResult<GetGenomeQuery, GetGenomeQueryVariables>;